import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { InputStepComponent } from '../../step/input-step/input-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-email',
    templateUrl: './email.component.html',
    styleUrls: ['./email.component.scss', '../../step/step.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    standalone: false
})
export class EmailComponent extends InputStepComponent implements OnInit {
  title = 'Almost there. Email?';
  subtitle = 'We take privacy seriously. No spam!';
  submitButtonText = 'Continue';
  isIconTest = false;

  @ViewChild('email') emailField: ElementRef;

  ngOnInit() {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.control = this.form.contains('email')
      ? this.form.get('email') as UntypedFormControl
      : new UntypedFormControl('');
    this.control.setValidators([Validators.required, Validators.email, Validators.pattern(re)]);
    this.control.updateValueAndValidity();
    if (!this.form.contains('email')) { this.form.addControl('email', this.control); }
  }

  initStep() {
    this.analyticsService.getExperiments().subscribe(
      (variationData: any) => {
        // if (variationData.enabledVariations.hasOwnProperty('FRU-16868')) {
        //   this.submitButtonText = 'Get My Rates';
        // }
      }
    );

    // Give email focus
    setTimeout(() => this.emailField.nativeElement.focus(), 0);

    if (!environment.production && this.randomService.fillEnabled) {
      this.form.controls.email.setValue(this.randomService.consumer.emailAddress);
    }
  }

}
